// Sticky class su .header__column.header__column--right oltre 300px
document.addEventListener('DOMContentLoaded', function () {
  var THRESHOLD = 300;
  var TARGET_SELECTOR = '.header__column.header__column--right';
  var EL_CLASS = 'search__sticky';
  var HTML_CLASS = 'has-search-sticky'; // fallback globale

  function toggleClasses() {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    // fallback globale sul <html> (utile se il nodo di header cambia in runtime)
    if (y >= THRESHOLD) {
      document.documentElement.classList.add(HTML_CLASS);
    } else {
      document.documentElement.classList.remove(HTML_CLASS);
    }

    // prova ad applicare direttamente al/i target corrente/i
    var nodes = document.querySelectorAll(TARGET_SELECTOR);
    if (nodes.length) {
      nodes.forEach(function (el) {
        if (y >= THRESHOLD) el.classList.add(EL_CLASS);
        else el.classList.remove(EL_CLASS);
      });
    }
  }

  // eventi
  window.addEventListener('scroll', toggleClasses, { passive: true });
  window.addEventListener('resize', toggleClasses, { passive: true });

  // se il tema reinserisce l'header (es. sticky header duplicato), ri-applica
  var mo = new MutationObserver(function () { toggleClasses(); });
  mo.observe(document.documentElement, { subtree: true, childList: true });

  // prima applicazione
  toggleClasses();
});


document.addEventListener('DOMContentLoaded', function () {
  var MOBILE_MAX = 749;
  var cols = Array.prototype.slice.call(
    document.querySelectorAll('.footer__content--col.accordion')
  );

  if (!cols.length) return;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  // Helpers per slide animato con display:none allo stato chiuso
  function slideUp(el, duration) {
    if (!el) return;
    el.style.overflow = 'hidden';
    el.style.maxHeight = el.scrollHeight + 'px'; // set base
    // forza reflow
    el.offsetHeight;
    el.style.transition = 'max-height ' + duration + 'ms ease';
    el.style.maxHeight = '0px';

    function onEnd(e) {
      if (e.propertyName !== 'max-height') return;
      el.style.display = 'none';
      el.style.transition = '';
      el.style.maxHeight = '';
      el.style.overflow = '';
      el.removeEventListener('transitionend', onEnd);
    }
    el.addEventListener('transitionend', onEnd);
  }

  function slideDown(el, duration) {
    if (!el) return;
    el.style.display = 'block';
    var target = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.maxHeight = '0px';
    // forza reflow
    el.offsetHeight;
    el.style.transition = 'max-height ' + duration + 'ms ease';
    el.style.maxHeight = target + 'px';

    function onEnd(e) {
      if (e.propertyName !== 'max-height') return;
      // dopo l’animazione, lascia altezza auto
      el.style.transition = '';
      el.style.maxHeight = '';
      el.style.overflow = '';
      el.removeEventListener('transitionend', onEnd);
    }
    el.addEventListener('transitionend', onEnd);
  }

  function initMobile() {
    cols.forEach(function (col, i) {
      var title = col.querySelector('.title');
      var content = col.querySelector('.content');
      if (!title || !content) return;

      // freccia U+276F (❯)
      if (!title.querySelector('.arrow')) {
        var arrow = document.createElement('span');
        arrow.className = 'arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.innerHTML = '&#x276F;'; // ❯
        title.appendChild(arrow);
      }

      // stato iniziale: tutto chiuso
      col.classList.remove('open');
      title.setAttribute('aria-expanded', 'false');
      content.style.display = 'none';
      content.style.maxHeight = '0';

      // evita doppi bind
      if (title.dataset.bound === '1') return;
      title.dataset.bound = '1';

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');

      function toggle() {
        var isOpen = col.classList.contains('open');

        // chiudi tutti gli altri (accordion esclusivo)
        cols.forEach(function (other) {
          if (other === col) return;
          var t = other.querySelector('.title');
          var c = other.querySelector('.content');
          if (!t || !c) return;
          if (other.classList.contains('open')) {
            other.classList.remove('open');
            t.setAttribute('aria-expanded', 'false');
            slideUp(c, 250);
          }
        });

        // toggle corrente
        if (isOpen) {
          col.classList.remove('open');
          title.setAttribute('aria-expanded', 'false');
          slideUp(content, 250);
        } else {
          col.classList.add('open');
          title.setAttribute('aria-expanded', 'true');
          slideDown(content, 250);
        }
      }

      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); toggle();
        }
      });

      // aggiorna altezza se il contenuto cambia (es. immagini)
      var ro = new ResizeObserver(function () {
        if (col.classList.contains('open') && content.style.display === 'block') {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
      ro.observe(content);
    });
  }

  function initDesktop() {
    cols.forEach(function (col) {
      var title = col.querySelector('.title');
      var content = col.querySelector('.content');
      if (!title || !content) return;
      col.classList.add('open');
      title.setAttribute('aria-expanded', 'true');
      content.style.display = 'block';
      content.style.maxHeight = '';
      content.style.overflow = '';
    });
  }

  function apply() {
    if (isMobile()) {
      initMobile();
    } else {
      initDesktop();
    }
  }

  apply();
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(apply, 150);
  });
});

// CONDIVIDI PRODOTTO - PDP
document.addEventListener('DOMContentLoaded', function () {

  const instagramShareButton = document.querySelector('.product-share-instagram');
  const shareMessage = document.querySelector('.product-share-message');

  if (!instagramShareButton) return;

  instagramShareButton.addEventListener('click', async function () {

    const url = this.dataset.shareUrl;
    const title = this.dataset.shareTitle;

    const shareData = {
      title: title,
      text: title,
      url: url
    };

    /*
     * MOBILE / BROWSER COMPATIBILI
     * Apre il menu nativo di condivisione.
     * Instagram comparirà se disponibile sul dispositivo.
     */
    if (navigator.share) {

      try {

        await navigator.share(shareData);

      } catch (error) {

        /*
         * Se l'utente chiude semplicemente
         * il menu di condivisione non facciamo nulla.
         */
        if (error.name !== 'AbortError') {
          console.error('Errore condivisione:', error);
        }

      }

      return;
    }


    /*
     * FALLBACK DESKTOP
     * Copia il link del prodotto.
     */
    try {

      await navigator.clipboard.writeText(url);

      if (shareMessage) {

        shareMessage.textContent =
          'Link copiato! Ora puoi incollarlo su Instagram.';

        setTimeout(function () {
          shareMessage.textContent = '';
        }, 4000);

      }

    } catch (error) {

      console.error('Impossibile copiare il link:', error);

    }

  });

});


/* ============================================================
   PLP - EVITA FLASH BIANCO IMMAGINI PRODOTTO
   ============================================================ */

(function () {

  const selector =
    '.collections-index .product-card__content .product-media__image';

  function prepareImage(img) {

    if (!img || img.dataset.bbImageReady === 'true') {
      return;
    }

    img.dataset.bbImageReady = 'true';

    function showImage() {

      /*
       * Aspettiamo due frame.
       * Il primo permette al browser di decodificare/renderizzare l'immagine.
       * Il secondo permette di applicare correttamente mix-blend-mode.
       */
      requestAnimationFrame(function () {

        requestAnimationFrame(function () {
          img.classList.add('bb-image-ready');
        });

      });
    }

    if (img.complete && img.naturalWidth > 0) {
      showImage();
    } else {
      img.addEventListener('load', showImage, {
        once: true
      });
    }

  }


  function initProductImages(container) {

    const scope = container || document;

    scope.querySelectorAll(selector).forEach(function (img) {
      prepareImage(img);
    });

  }


  document.addEventListener('DOMContentLoaded', function () {

    initProductImages(document);

    /*
     * Serve anche quando Shopify aggiorna la PLP
     * tramite filtri, ordinamento, infinite loading, ecc.
     */
    const collection = document.querySelector('.collections-index');

    if (!collection) {
      return;
    }

    const observer = new MutationObserver(function (mutations) {

      mutations.forEach(function (mutation) {

        mutation.addedNodes.forEach(function (node) {

          if (!(node instanceof HTMLElement)) {
            return;
          }

          if (node.matches && node.matches(selector)) {
            prepareImage(node);
          }

          node.querySelectorAll?.(selector).forEach(function (img) {
            prepareImage(img);
          });

        });

      });

    });

    observer.observe(collection, {
      childList: true,
      subtree: true
    });

  });

})();
